export default function getUsername(state) {
  let username = "";
  if (state.loginForm && state.loginForm.username) {
    username = state.loginForm.username.trim();
  }
  return username;
}